/** Multiplicador de rueda en paneles laterales scrolleables (edge / studio). */
export const PANEL_WHEEL_SCROLL_SCALE = 1.55

/**
 * Acelera scroll vertical con rueda en un contenedor overflow.
 * @param {HTMLElement|null|undefined} el
 * @param {number} [scale]
 * @returns {() => void} cleanup
 */
export function attachBoostedWheelScroll(el, scale = PANEL_WHEEL_SCROLL_SCALE) {
  if (!el || typeof el.addEventListener !== 'function') {
    return () => {}
  }

  const onWheel = (e) => {
    if (!e || e.shiftKey) return
    if (el.scrollHeight <= el.clientHeight + 1) return

    const dy = e.deltaY
    if (!dy) return

    const maxScroll = el.scrollHeight - el.clientHeight
    const next = el.scrollTop + dy * scale
    const clamped = Math.max(0, Math.min(maxScroll, next))
    if (Math.abs(clamped - el.scrollTop) < 0.5) return

    e.preventDefault()
    el.scrollTop = clamped
  }

  el.addEventListener('wheel', onWheel, { passive: false })
  return () => {
    el.removeEventListener('wheel', onWheel)
  }
}
